import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from 'src/components/Sidebar';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import MobileFooter from 'src/components/MobileFooter';
import { getAssignedPermissionsForCurrentUser } from 'src/redux/Actions/Auth';
import { useDispatch, useSelector } from 'react-redux';
import config from 'src/config/config';
import { clearGlobalError } from 'src/redux/Actions/GlobalError';
import ErrorToast from 'src/components/ErrorToast';

function Layout() {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const isMobile = useMediaQuery('(max-width:767px)');
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer?.userData?.organisations?.id;

  const globalErrors = useSelector(
    (state) => state.globalError?.errorMessages || {},
  );

  useEffect(() => {
    const fetchPermissions = async () => {
      if (tenantOrganisationId) {
        dispatch(
          getAssignedPermissionsForCurrentUser(
            tenantOrganisationId,
            config.app_label_id,
          ),
        );
      }
    };
    fetchPermissions();
  }, [dispatch, tenantOrganisationId]);

  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      {globalErrors?.length > 0 && (
        <Box
          className="body-container-scroller"
          sx={{
            position: 'fixed',
            bottom: isMobile ? '70px' : '10px',
            right: 0,
            width: isMobile ? '100vw' : '28vw',
            maxHeight: isMobile ? 'calc(100vh - 120px)' : 'calc(100vh - 62px)',
            overflowY: 'auto',
            padding: '10px',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column-reverse',
            gap: 1,
            pointerEvents: 'none',
          }}
        >
          {globalErrors.map((error) => (
            <div style={{ pointerEvents: 'auto' }} key={error?.id}>
              <ErrorToast
                id={error?.id}
                message={error?.message}
                errorList={error?.errorList}
                onClose={(id) => dispatch(clearGlobalError(id))}
              />
            </div>
          ))}
        </Box>
      )}

      {token ? (
        <>
          <Sidebar />
          <div className="app-main-content div-flex-column">
            <Outlet />
            {isMobile && <MobileFooter />}
          </div>
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </Box>
  );
}

export default Layout;
